import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GlobalSearchPaletteComponent } from '../components/global-search/global-search-palette.component';

@Injectable({ providedIn: 'root' })
export class GlobalSearchService {
  private readonly _dialog = inject(MatDialog);

  public open() {
    const isAlreadyOpen = this._dialog.openDialogs.some(
      dialogRef => dialogRef.componentInstance instanceof GlobalSearchPaletteComponent,
    );

    if (isAlreadyOpen) {
      return;
    }

    this._dialog.open(GlobalSearchPaletteComponent, {
      panelClass: 'global-search-panel',
      autoFocus: true,
      width: '600px',
      position: { top: '15vh' },
    });
  }
}
